import { PassouFalhouEnum } from '@mchat-rf/consulta-seguimento/enums-consultaSeguimento'
import { hasAnySim, isAllFilled, isAllNao } from '@mchat-rf/consulta-seguimento/utils-consultaSeguimento'
import { SimNaoEnum } from 'components/form'
import { isEmpty } from 'util/checks'

import {
  ConsultaSeguimentoPergunta16ExemplosEnum,
  ConsultaSeguimentoPergunta16Model,
} from './model-consultaSeguimentoPergunta16'

const pergunta16ExemplosPassouEnumValues = [
  ConsultaSeguimentoPergunta16ExemplosEnum.OLHA_PARA_O_QUE_VOCE_ESTA_OLHANDO,
  ConsultaSeguimentoPergunta16ExemplosEnum.APONTA_PARA_O_QUE_VOCE_ESTA_OLHANDO,
  ConsultaSeguimentoPergunta16ExemplosEnum.OLHA_AO_REDOR_PARA_O_QUE_VOCE_ESTA_OLHANDO,
]
const pergunta16ExemplosFalhouEnumValues = [
  ConsultaSeguimentoPergunta16ExemplosEnum.NAO_REPARA_EM_VOCE,
  ConsultaSeguimentoPergunta16ExemplosEnum.OLHA_PARA_SEU_ROSTO,
]

export function isPergunta16ExemplosAllFilled(
  value: ConsultaSeguimentoPergunta16Model['PERGUNTA_16_EXEMPLOS']
): boolean {
  return (
    isAllFilled(value?.PASSOU, pergunta16ExemplosPassouEnumValues) &&
    isAllFilled(value?.FALHOU, pergunta16ExemplosFalhouEnumValues)
  )
}

export function isPergunta16ExemplosAllNao(value: ConsultaSeguimentoPergunta16Model['PERGUNTA_16_EXEMPLOS']): boolean {
  return (
    isAllNao(value?.PASSOU, pergunta16ExemplosPassouEnumValues) &&
    isAllNao(value?.FALHOU, pergunta16ExemplosFalhouEnumValues)
  )
}

export function hasPergunta16ExemplosPassouAnySim(
  value: ConsultaSeguimentoPergunta16Model['PERGUNTA_16_EXEMPLOS']
): boolean {
  return hasAnySim(value?.PASSOU)
}

export function hasPergunta16ExemplosFalhouAnySim(
  value: ConsultaSeguimentoPergunta16Model['PERGUNTA_16_EXEMPLOS']
): boolean {
  return hasAnySim(value?.FALHOU)
}

export function prunePergunta16(value: ConsultaSeguimentoPergunta16Model): ConsultaSeguimentoPergunta16Model {
  const pruned: ConsultaSeguimentoPergunta16Model = {
    status: value.status,
    resultado: value.resultado,
    PERGUNTA_16_HEADER: value.PERGUNTA_16_HEADER,
  }

  const isHeaderNao = value.PERGUNTA_16_HEADER === SimNaoEnum.NAO
  const hasPerguntaExemplosPassouAnySim = hasPergunta16ExemplosPassouAnySim(value.PERGUNTA_16_EXEMPLOS)
  const hasPerguntaExemplosFalhouAnySim = hasPergunta16ExemplosFalhouAnySim(value.PERGUNTA_16_EXEMPLOS)

  if (isHeaderNao) {
    pruned.PERGUNTA_16_EXEMPLOS = value.PERGUNTA_16_EXEMPLOS
  }

  if (isHeaderNao && hasPerguntaExemplosPassouAnySim && hasPerguntaExemplosFalhouAnySim) {
    pruned.PERGUNTA_16_FREQUENCIA = value.PERGUNTA_16_FREQUENCIA
  }

  return pruned
}

export function conditionToCalculatePergunta16(values: ConsultaSeguimentoPergunta16Model): boolean {
  if (values.PERGUNTA_16_HEADER === SimNaoEnum.SIM) {
    return true
  }

  if (
    !isPergunta16ExemplosAllFilled(values.PERGUNTA_16_EXEMPLOS) ||
    isPergunta16ExemplosAllNao(values.PERGUNTA_16_EXEMPLOS)
  ) {
    return false
  }

  const hasPerguntaExemplosPassouAnySim = hasPergunta16ExemplosPassouAnySim(values.PERGUNTA_16_EXEMPLOS)
  const hasPerguntaExemplosFalhouAnySim = hasPergunta16ExemplosFalhouAnySim(values.PERGUNTA_16_EXEMPLOS)

  if (
    (hasPerguntaExemplosPassouAnySim && !hasPerguntaExemplosFalhouAnySim) ||
    (hasPerguntaExemplosFalhouAnySim && !hasPerguntaExemplosPassouAnySim)
  ) {
    return true
  } else {
    return !isEmpty(values.PERGUNTA_16_FREQUENCIA)
  }
}

export function calculateResultadoPergunta16(values: ConsultaSeguimentoPergunta16Model): PassouFalhouEnum | undefined {
  if (values.PERGUNTA_16_HEADER === SimNaoEnum.SIM) {
    return PassouFalhouEnum.PASSOU
  }

  const hasPerguntaExemplosPassouAnySim = hasPergunta16ExemplosPassouAnySim(values.PERGUNTA_16_EXEMPLOS)
  const hasPerguntaExemplosFalhouAnySim = hasPergunta16ExemplosFalhouAnySim(values.PERGUNTA_16_EXEMPLOS)

  if (hasPerguntaExemplosPassouAnySim && !hasPerguntaExemplosFalhouAnySim) {
    return PassouFalhouEnum.PASSOU
  } else if (hasPerguntaExemplosFalhouAnySim && !hasPerguntaExemplosPassouAnySim) {
    return PassouFalhouEnum.FALHOU
  } else {
    return values.PERGUNTA_16_FREQUENCIA
  }
}
